import React from "react";
import {
  Button,
  Checkbox,
  Flex,
  Input,
  Select,
} from "@chakra-ui/react";

export default function ProductFilters({
  filters,
  brands,
  categories,
  subCategories,
  families,
  productCode,
  searchText,
  itemsPerPage,
  showSelectedOnly,
  onFilterChange,
  onCodeChange,
  onSearchTextChange,
  onPageSizeChange,
  onShowSelectedToggle,
  onReset,
}) {
  const { brand_id, categories_id, subcategory_id, family_id } = filters;

  return (
    <Flex
      wrap="wrap"
      gap={2}
      mb={6}
      width="80%"
      position="sticky"
      top="0"
      bg="whiteAlpha.800"
      backdropFilter="blur(4px)"
      zIndex="2"
    >
      <Input
        size="sm"
        maxW="180px"
        placeholder="Cerca per codice"
        value={productCode}
        onChange={(e) => onCodeChange(e.target.value)}
      />
      <Input
        size="sm"
        maxW="180px"
        placeholder="Cerca nella descrizione"
        value={searchText}
        onChange={(e) => onSearchTextChange(e.target.value)}
      />

      {/* Brand */}
      <Select
        size="sm"
        maxW="200px"
        placeholder="Seleziona brand"
        value={brand_id}
        onChange={(e) =>
          onFilterChange((f) => ({ ...f, brand_id: e.target.value }))
        }
      >
        {brands.map((b) => (
          <option key={b.id} value={b.id}>
            {b.name}
          </option>
        ))}
      </Select>

      {/* Categoria */}
      <Select
        size="sm"
        maxW="200px"
        placeholder="Seleziona categoria"
        value={categories_id}
        onChange={(e) =>
          onFilterChange((f) => ({ ...f, categories_id: e.target.value }))
        }
      >
        {categories.map((c) => (
          <option key={c.id} value={c.id}>
            {c.nome}
          </option>
        ))}
      </Select>

      {/* Sottocategoria */}
      <Select
        size="sm"
        maxW="200px"
        placeholder="Seleziona sottocategoria"
        value={subcategory_id}
        onChange={(e) =>
          onFilterChange((f) => ({ ...f, subcategory_id: e.target.value }))
        }
      >
        {subCategories.map((sc) => (
          <option key={sc.id} value={sc.id}>
            {sc.title}
          </option>
        ))}
      </Select>

      {/* Famiglia */}
      <Select
        size="sm"
        maxW="200px"
        placeholder="Seleziona famiglia"
        value={family_id}
        onChange={(e) =>
          onFilterChange((f) => ({ ...f, family_id: e.target.value }))
        }
      >
        {families.map((fam) => (
          <option key={fam.id} value={fam.id}>
            {fam.title}
          </option>
        ))}
      </Select>

      {/* Righe per pagina */}
      <Select
        size="sm"
        maxW="160px"
        value={itemsPerPage}
        onChange={(e) => onPageSizeChange(+e.target.value)}
      >
        {[15, 25, 50].map((n) => (
          <option key={n} value={n}>
            {n} righe
          </option>
        ))}
      </Select>

      <Button size="sm" onClick={onReset}>
        Azzera filtri
      </Button>

      <Checkbox
        size="sm"
        isChecked={showSelectedOnly}
        onChange={onShowSelectedToggle}
      >
        Prodotti selezionati
      </Checkbox>
    </Flex>
  );
}
